export enum CampActualType {
  External = 'external',
  HistoricDifference = 'historicDifference',
  Actual = 'actual'
}
